export { default as getTableScrollX } from './getTableScrollX';

export const COLUMNS_WIDTH = {
  default: 120,
  small: 80,
  extraSmall: 60,
  price: 100,
  document: 140,
  date: 85,
  action1: 150,
  action2: 250,
  billToPay: 240,
};

export const tableSorterOrder: Record<string, 'ASC' | 'DESC'> = {
  ascend: 'ASC',
  descend: 'DESC',
};

export const tableSorterColumn: Record<
  string,
  'DESCRIPTION' | 'MANUFACTURING_CODE' | 'BARCODE' | 'SKU' | 'COMPANY_CODE'
> = {
  name: 'DESCRIPTION',
  manufacturingCode: 'MANUFACTURING_CODE',
  barCode: 'BARCODE',
  sku: 'SKU',
  companyCode: 'COMPANY_CODE',
};
